import operation from '../../crudInterface/operations';
export const setLocal = (type, payload, replace = true) => ({
    type,
    payload,
    operation: operation.GET,
    replace,
});
